var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99967,
    cy: 8.00016,
    r: 6.66667,
    fill: "#89888E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77734 5.77783L7.99957 8.00005M7.99957 8.00005L10.2218 10.2223M7.99957 8.00005L10.2218 5.77783M7.99957 8.00005L5.77734 10.2223",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCircleSolid);
export default __webpack_public_path__ + "static/media/Clear Circle Solid.72a470af5b1506063e98b5a7e1d13865.svg";
export { ForwardRef as ReactComponent };